import { IRootState } from '../../../store'
import { IImagingUltrasoundOptionsState } from '../store/options.types'

export const getImagingUltrasoundOptionsSelector = (state: IRootState): IImagingUltrasoundOptionsState =>
  state.options.imagingUltrasoundOptions
